"use client";
import { useLocation, useParams } from "react-router-dom";
import { ChapterImageEditor } from "../components/image/ChapterImageEditor";
import { ActivityImageEditor } from "../components/image/ActivityImageEditor";

const EditImagePage = () => {
  const location = useLocation();
  const { id } = useParams<{ id: string }>();

  const isChapterImage = location.pathname.includes("/chapter/");

  return isChapterImage ? (
    <ChapterImageEditor id={id || ""} />
  ) : (
    <ActivityImageEditor id={id || ""} />
  );
};

export default EditImagePage;
